import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

/**
 * Fetches the real asset list for a brand from the dedicated assets store
 * (same Lambda as createAsset — request_type: "studio/create_asset",
 * routed via request_sub_type).
 */
export async function listAssets(appConfig, brandId, setIsLoading, setApiResponse) {
  const payload = {
    request_type: "studio/create_asset",
    request_sub_type: "list_assets",
    client_id: appConfig.clientId,
    brand_id: brandId,
  };

  const response = await ApiGatewayFunction(
    payload,
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );

  return response?.data?.assets ?? [];
}